import React, { useState } from 'react';
import { LoginScreen } from './screens/LoginScreen';
import { CasesScreen } from './screens/CasesScreen';
import { ReviewScreen } from './screens/ReviewScreen';
import { MembersScreen } from './screens/MembersScreen';
import { LoadingScreen } from './screens/LoadingScreen';
import { EmptyScreen } from './screens/EmptyScreen';
import { SessionExpiredScreen, AccessDeniedScreen } from './screens/SessionStates';
type ScreenState = 'login' | 'cases' | 'review' | 'members' | 'loading' | 'empty' | 'session-expired' | 'access-denied';
export function App() {
  const [currentScreen, setCurrentScreen] = useState<ScreenState>('login');
  const handleLogin = () => {
    setCurrentScreen('cases');
  };
  const handleLogout = () => {
    setCurrentScreen('login');
  };
  const handleSelectCase = (caseId: string) => {
    setCurrentScreen('loading');
    // Simulate loading delay
    setTimeout(() => {
      setCurrentScreen('review');
    }, 1500);
  };
  // Render the appropriate screen based on state
  switch (currentScreen) {
    case 'login':
      return <LoginScreen onLogin={handleLogin} data-id="element-0" />;
    case 'cases':
      return <CasesScreen onSelectCase={handleSelectCase} onLogout={handleLogout} data-id="element-1" />;
    case 'review':
      return <ReviewScreen onLogout={handleLogout} onNavigateMembers={() => setCurrentScreen('members')} onNavigateCases={() => setCurrentScreen('cases')} data-id="element-2" />;
    case 'members':
      return <MembersScreen onBack={() => setCurrentScreen('review')} onLogout={handleLogout} data-id="element-3" />;
    case 'loading':
      return <LoadingScreen data-id="element-4" />;
    case 'empty':
      return <EmptyScreen onLogout={handleLogout} onClearFilters={() => setCurrentScreen('review')} data-id="element-5" />;
    case 'session-expired':
      return <SessionExpiredScreen onAction={() => setCurrentScreen('login')} data-id="element-6" />;
    case 'access-denied':
      return <AccessDeniedScreen onAction={() => setCurrentScreen('cases')} data-id="element-7" />;
    default:
      return <LoginScreen onLogin={handleLogin} data-id="element-8" />;
  }
}